module.exports = new __parcel__URL__("fur69_chip.5dd77b43.png").toString();